import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'
import useLocales from './useLocales'

export function usePreventUnsavedChanges(
  pathName: string,
  warningText: string = 'key_do_you_want_to_leave_the_page_changes_you_make_may_be_lost',
) {
  const { t } = useLocales()
  const router = useRouter()

  const unsavedChanges = true

  const handleWindowClose = useCallback((e) => {
    if (!unsavedChanges) return
    e.preventDefault()
    return (e.returnValue = t(warningText))
  }, [])

  const handleBrowseAway = useCallback((e) => {
    const isTargetURL = e === pathName
    if (!unsavedChanges || isTargetURL) return
    if (window.confirm(t(warningText))) return
    router.events.emit('routeChangeError')
    throw 'routeChange aborted.'
  }, [])

  const subscribeToRouteChangeGuard = () => {
    window.addEventListener('beforeunload', handleWindowClose)
    router.events.on('routeChangeStart', handleBrowseAway)
  }

  const unsubscribeToRouteChangeGuard = () => {
    window.removeEventListener('beforeunload', handleWindowClose)
    router.events.off('routeChangeStart', handleBrowseAway)
  }

  useEffect(() => {
    subscribeToRouteChangeGuard()

    return () => unsubscribeToRouteChangeGuard()
  }, [])

  return {
    unsubscribeToRouteChangeGuard,
  }
}
